/* eslint-disable no-undef */
import Vue from 'vue'
import { namespace } from 'vuex-class'
import {MAINTENANCE_MODULE_NAMESPACE, MAINTENANCE_SET_BY_FIELD} from '../../../../store/maintenance'
import { IMaintenance } from '../../../../models/maintenance/maintenance.model'

const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)

export class MaintenaceViewmodal extends Vue {
  @MaintenanceStore.Getter maintenance : IMaintenance

  @MaintenanceStore.Mutation(MAINTENANCE_SET_BY_FIELD)
  storeAssignValueForMaintenance: (payload: IMaintenance) => void;

  get name () {
    return this.maintenance.name
  }

  set name (value: string) {
    this.storeAssignValueForMaintenance({ name: value })
  }

  get description () {
    return this.maintenance.description
  }

  set description (value: string) {
    this.storeAssignValueForMaintenance({ description: value })
  }

  get type () {
    return this.maintenance.type
  }

  set type (value: string) {
    this.storeAssignValueForMaintenance({ type: value })
  }

  get state () {
    return this.maintenance.state
  }

  set state (value: string) {
    this.storeAssignValueForMaintenance({ state: value })
  }

  get method () {
    return this.maintenance.method
  }

  set method (value: string) {
    this.storeAssignValueForMaintenance({ method: value })
  }

  get date () {
    return this.maintenance.last_maintenance_date
  }

  set date (value: string) {
    this.storeAssignValueForMaintenance({ last_maintenance_date: value })
  }

  get FKMaintenanceIntervalType () {
    return this.maintenance.fk_interval_type
  }

  set FKMaintenanceIntervalType (value: number) {
    this.storeAssignValueForMaintenance({ fk_interval_type: value })
  }

  get FKMaintenanceTemplate () {
    return this.maintenance.fk_template
  }

  set FKMaintenanceTemplate (value: number) {
    this.storeAssignValueForMaintenance({ fk_template: value })
  }

  get FKEquipment () {
    return this.maintenance.fk_equipment
  }

  set FKEquipment (value: number) {
    this.storeAssignValueForMaintenance({ fk_equipment: value })
  }

  get use_as_template () {
    return this.maintenance.use_as_template
  }

  set use_as_template (value: boolean) {
    this.storeAssignValueForMaintenance({ use_as_template: value })
  }

  get FKAttribute () {
    return this.maintenance.fk_attribute
  }

  set FKAttribute (value: number) {
    this.storeAssignValueForMaintenance({ fk_attribute: value })
  }


  get interval () : number {
    return this.maintenance.interval
  }

  set interval (value: number) {
    this.storeAssignValueForMaintenance({ interval: value })
  }

  get attribut_value_maintenance () : number | string {
    return this.maintenance.last_maintenance_value
  }

  set attribut_value_maintenance (value: number | string) {
    this.storeAssignValueForMaintenance({ last_maintenance_value: value })
  }

  get alertPreDelay () {
    return this.maintenance.alert_pre_delay
  }

  set alertPreDelay (value: number) {
    this.storeAssignValueForMaintenance({ alert_pre_delay: value })
  }

  get manager () : number {
    return this.maintenance.fk_entity_manager_assign
  }

  set manager (value: number) {
    this.storeAssignValueForMaintenance({ fk_entity_manager_assign: value })
  }

  get contractor () : number {
    return this.maintenance.fk_entity_contractor
  }

  set contractor (value: number) {
    this.storeAssignValueForMaintenance({ fk_entity_contractor: value })
  }
}



// WEBPACK FOOTER //
// ./src/containers/block/components/block-maintenance-modal-vertical/maintenance.viewmodal.ts